/* kx-cart-products.js
   Warenkorb-Skripte, bis 27.09.2026 als sechs Inline-<script>-Bloecke in
   snippets/cart-products.liquid. Sie liefen mit jedem Seitenaufruf im HTML mit
   (~10 KB gzip auf jeder Seite, weil der Drawer im Header sitzt); als Datei
   kommen sie ab dem zweiten Aufruf aus dem Browser-Cache.
   Inhalt woertlich uebernommen. Einzige Aenderung: die zwei Wunschlisten-Texte
   kamen per Liquid (| json) und kommen jetzt aus window.KX_CART_I18N, das das
   Snippet direkt vor dieser Datei setzt.
   Jeder frueher eigene Block steht in einem eigenen try: ein Fehler in einem
   Block haelt die anderen nicht auf (wie bei getrennten <script>-Tags) und
   wird trotzdem als unbehandelter Fehler gemeldet.
   Laden mit defer: laeuft nach dem Parsen, vor DOMContentLoaded. Alle Bloecke
   arbeiten mit document-weiten Listenern bzw. Retry-Schleifen und sind davon
   unabhaengig. */

/* ── Block 1 (vormals cart-products.liquid, Zeile 1457) ── */
/*
   ═══════════════════════════════════════════════════════
   WIRD OFT ZUSAMMEN GEKAUFT — add-to-cart from drawer
   Handles "Hinzufügen" buttons in .cart-reco-wrapper.
   After add: updates cart items, badge, summary, and reco
   strip from the fresh server-rendered section HTML.
   Listens for cart:refresh to sync when items are removed.
   ═══════════════════════════════════════════════════════
*/
try {
(function () {
  function _recoSectionId() {
    var c = document.querySelector('.cart-drawer cart-items-component');
    return c && c.dataset ? c.dataset.sectionId : null;
  }

  /** Re-render the cart items <tbody> from fresh section HTML so the
   *  newly added product appears instantly without a page reload. */
  function _updateCartItemsFromHTML(sectionHTML) {
    try {
      var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var newTbody = doc.querySelector('tbody[role="rowgroup"]');
      var oldTbody = document.querySelector('.cart-drawer tbody[role="rowgroup"]');
      if (newTbody && oldTbody) {
        oldTbody.replaceWith(newTbody);
      } else if (newTbody) {
        /* Drawer is in its EMPTY state ("Dein Warenkorb ist leer" +
           Zuletzt angesehen): there is no tbody — and no summary — in the
           DOM, so the tbody swap silently did nothing and the added item
           only appeared after a full reload. The empty/full variants are
           both rendered inside <cart-items-component>, so rebuilding the
           component body from the fresh section HTML restores everything
           at once: header badge, rows, and the summary footer. */
        var oldComp = document.querySelector('.cart-drawer cart-items-component');
        var newComp = doc.querySelector('cart-items-component');
        if (oldComp && newComp) oldComp.innerHTML = newComp.innerHTML;
        var dlg = document.querySelector('.cart-drawer__dialog');
        if (dlg) dlg.classList.remove('cart-drawer--empty');
      }
    } catch (e) {}
  }

  /** Update all cart badge elements from the rendered section HTML */
  function _updateBadgeFromHTML(sectionHTML) {
    try {
      var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var countEl = doc.querySelector('.cart-drawer__count');
      var n = countEl ? parseInt(countEl.textContent.trim(), 10) : NaN;
      if (isNaN(n)) return;
      document.querySelectorAll('cart-icon').forEach(function (icon) {
        var refs = icon.refs;
        var bc = refs ? refs.cartBubbleCount : icon.querySelector('[ref="cartBubbleCount"]');
        var bb = refs ? refs.cartBubble : icon.querySelector('[ref="cartBubble"]');
        if (!bc || !bb) return;
        bc.textContent = (n > 0 && n < 100) ? String(n) : '';
        bc.classList.toggle('hidden', n === 0);
        bb.classList.toggle('visually-hidden', n === 0);
        bb.setAttribute('data-count', String(n));
        icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
      });
      var floatBadge = document.querySelector('.DISABLED-cart-count-badge');
      if (floatBadge) floatBadge.textContent = n > 0 ? String(n) : '';
      var mmBadge = document.querySelector('.cmm-cart-count');
      if (mmBadge) { mmBadge.textContent = String(n); mmBadge.style.display = n > 0 ? 'flex' : 'none'; }
    } catch (e) {}
  }

  /** Replace summary footer + heading count from fresh section HTML */
  function _updateSummaryFromHTML(sectionId, sectionHTML) {
    try {
      var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var newSummary = doc.querySelector('.cart-drawer__summary');
      var oldSummary = document.querySelector('.cart-drawer__summary');
      if (newSummary && oldSummary) oldSummary.innerHTML = newSummary.innerHTML;
      var countEl = doc.querySelector('.cart-drawer__count');
      var n = countEl ? parseInt(countEl.textContent.trim(), 10) : NaN;
      if (!isNaN(n)) {
        var liveCount = document.querySelector('.cart-drawer__count');
        if (liveCount) liveCount.textContent = n > 0 ? String(n) : '';
      }
    } catch (e) {}
  }

  /** Replace reco strip DOM from freshly rendered section HTML */
  function _refreshRecoFromHTML(sectionId, sectionHTML) {
    try {
      var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
      var newReco = doc.getElementById('cart-drawer-recommendations');
      var oldReco = document.getElementById('cart-drawer-recommendations');
      if (oldReco && newReco) {
        oldReco.replaceWith(newReco);
      } else if (oldReco && !newReco) {
        oldReco.remove();
      } else if (!oldReco && newReco) {
        var items = document.querySelector('.cart-drawer__items');
        if (items) items.appendChild(newReco);
      }
    } catch (e) {}
  }

  /** Collapse a horizontal row card (height → 0) then tidy the strip */
  function _removeCard(card) {
    var h = card.offsetHeight;
    card.style.maxHeight = h + 'px';
    card.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      card.style.transition = 'opacity 0.2s ease, max-height 0.3s ease 0.05s, padding-top 0.3s ease 0.05s, padding-bottom 0.3s ease 0.05s';
      card.style.opacity = '0';
      card.style.maxHeight = '0';
      card.style.paddingTop = '0';
      card.style.paddingBottom = '0';
    });
    setTimeout(function () {
      card.remove();
      var scroll = document.querySelector('.cart-reco-scroll');
      if (scroll && !scroll.querySelector('.cart-reco-card')) {
        var wrapper = document.getElementById('cart-drawer-recommendations');
        if (wrapper) {
          wrapper.style.transition = 'opacity 0.2s ease';
          wrapper.style.opacity = '0';
          setTimeout(function () { wrapper.remove(); }, 220);
        }
      }
    }, 380);
  }

  /* Same collapse animation for the "Zuletzt angesehen" rv-cards. */
  function _removeRvCard(card) {
    if (!card || !card.parentNode) return;
    var h = card.offsetHeight;
    card.style.maxHeight = h + 'px';
    card.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      card.style.transition = 'opacity 0.2s ease, max-height 0.3s ease 0.05s, padding-top 0.3s ease 0.05s, padding-bottom 0.3s ease 0.05s';
      card.style.opacity = '0';
      card.style.maxHeight = '0';
      card.style.paddingTop = '0';
      card.style.paddingBottom = '0';
    });
    setTimeout(function () {
      card.remove();
      var scroll = document.querySelector('.rv-scroll');
      if (scroll && !scroll.querySelector('.rv-card')) {
        var wrapper = document.querySelector('.rv-wrapper');
        if (wrapper) {
          wrapper.style.transition = 'opacity 0.2s ease';
          wrapper.style.opacity = '0';
          setTimeout(function () { wrapper.remove(); }, 220);
        }
      }
    }, 380);
  }

  /** Optimistically increment all badge elements by 1 before server responds */
  function _optimisticBadgeIncrement() {
    try {
      document.querySelectorAll('cart-icon').forEach(function (icon) {
        var refs = icon.refs;
        var bc = refs ? refs.cartBubbleCount : icon.querySelector('[ref="cartBubbleCount"]');
        var bb = refs ? refs.cartBubble : icon.querySelector('[ref="cartBubble"]');
        if (!bc || !bb) return;
        var n = (parseInt(bc.textContent, 10) || 0) + 1;
        bc.textContent = n < 100 ? String(n) : '99+';
        bc.classList.remove('hidden');
        bb.classList.remove('visually-hidden');
        bb.setAttribute('data-count', String(n));
        icon.classList.add('header-actions__cart-icon--has-cart');
      });
      var fb = document.querySelector('.DISABLED-cart-count-badge');
      if (fb) fb.textContent = String((parseInt(fb.textContent, 10) || 0) + 1);
      var mb = document.querySelector('.cmm-cart-count');
      if (mb) { mb.textContent = String((parseInt(mb.textContent, 10) || 0) + 1); mb.style.display = 'flex'; }
      /* Cart-drawer count badge next to "Warenkorb". Bump by 1. */
      document.querySelectorAll('[data-cart-count-badge]').forEach(function (el) {
        var n = (parseInt(el.textContent, 10) || 0) + 1;
        el.textContent = String(n);
        el.hidden = false;
      });
    } catch (e) {}
  }

  /* ── Circular "+" add button ── */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cart-reco-btn');
    if (!btn) return;
    var variantId = btn.dataset.variantId;
    if (!variantId || btn.disabled || btn.classList.contains('cart-reco-btn--loading')) return;

    var sectionId = _recoSectionId();
    if (!sectionId) return;

    var card = btn.closest('.cart-reco-card');

    // Instant feedback: optimistic badge + loading state.
    // NOTE: we intentionally do NOT set btn.disabled = true here —
    // the `:disabled { opacity: 0.28 }` rule would carry through to
    // the `--added` state and dim the ✓ check (rv-card doesn't
    // disable, so the two strips would look different). The
    // `--loading` class already blocks pointer-events, and the
    // `loading || added` guards above prevent double-clicks.
    btn.classList.add('cart-reco-btn--loading');
    _optimisticBadgeIncrement();

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1, sections: sectionId })
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'error'); });
      return r.json();
    })
    .then(function (data) {
      // Show success check, then begin card exit (~1s so ✓ is readable)
      btn.classList.remove('cart-reco-btn--loading');
      btn.classList.add('cart-reco-btn--added');

      var html = data.sections && data.sections[sectionId];
      if (html) {
        // Cart list, badge and summary update immediately so the new
        // line appears in the drawer right away.
        _updateCartItemsFromHTML(html);
        _updateBadgeFromHTML(html);
        _updateSummaryFromHTML(sectionId, html);
      }

      // Keep the ✓ visible for ~1s before collapsing the card. Then
      // refresh the rest of the reco strip from fresh HTML so any
      // empty slot gets filled with the next recommendation.
      if (card) {
        setTimeout(function () {
          _removeCard(card);
          if (html) setTimeout(function () { _refreshRecoFromHTML(sectionId, html); }, 450);
        }, 1000);
      } else if (html) {
        _refreshRecoFromHTML(sectionId, html);
      }
    })
    .catch(function (err) {
      btn.disabled = false;
      btn.classList.remove('cart-reco-btn--loading');
      // Revert optimistic badge via fresh cart state
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count;
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          var refs = icon.refs;
          var bc = refs ? refs.cartBubbleCount : icon.querySelector('[ref="cartBubbleCount"]');
          var bb = refs ? refs.cartBubble : icon.querySelector('[ref="cartBubble"]');
          if (!bc || !bb) return;
          bc.textContent = (n > 0 && n < 100) ? String(n) : '';
          bc.classList.toggle('hidden', n === 0);
          bb.classList.toggle('visually-hidden', n === 0);
          bb.setAttribute('data-count', String(n));
          icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
        });
        document.querySelectorAll('[data-cart-count-badge]').forEach(function (el) {
          if (n > 0) { el.textContent = String(n); el.hidden = false; }
          else { el.hidden = true; }
        });
      }).catch(function () {});
      console.warn('[cart-reco] add failed:', err);
    });
  });

  // Sync reco strip when items are removed via __cartMasterRemove
  document.addEventListener('cart:refresh', function (e) {
    try {
      var data = e.detail && e.detail.cart;
      if (!data || !data.sections) return;
      var sid = _recoSectionId();
      if (!sid || !data.sections[sid]) return;
      _refreshRecoFromHTML(sid, data.sections[sid]);
    } catch (e) {}
  });

  /* ── Recently Viewed (.rv-card__btn) ────────────────────────────
     The cart-recently-viewed section is injected via innerHTML
     by cart-drawer.js, so <script> tags inside it never execute.
     Bind the add handler here, where the IIFE is always loaded. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.rv-card__btn');
    if (!btn || btn.disabled || btn.classList.contains('rv-card__btn--loading')) return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    var card = btn.closest('.rv-card');
    var sectionId = _recoSectionId();
    btn.classList.add('rv-card__btn--loading');
    _optimisticBadgeIncrement();

    var body = { id: Number(variantId), quantity: 1 };
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    })
    .then(function (r) {
      if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'add failed'); });
      return r.json();
    })
    .then(function (data) {
      // Mirror the FBT (.cart-reco-btn) flow exactly so the visual
      // feedback is identical between both strips.
      btn.classList.remove('rv-card__btn--loading');
      btn.classList.add('rv-card__btn--added');

      var html = sectionId && data.sections && data.sections[sectionId];
      if (html) {
        // Cart list, badge and summary update immediately so the new
        // line appears in the drawer right away.
        _updateCartItemsFromHTML(html);
        _updateBadgeFromHTML(html);
        _updateSummaryFromHTML(sectionId, html);
      }

      // Keep the ✓ visible for ~1s, then collapse the card. After
      // the collapse, refresh the FBT strip so the next slot can
      // backfill — same timing as cart-reco-btn for parity.
      if (card) {
        setTimeout(function () {
          _removeRvCard(card);
          if (html) setTimeout(function () { _refreshRecoFromHTML(sectionId, html); }, 450);
        }, 1000);
      } else if (html) {
        _refreshRecoFromHTML(sectionId, html);
      }
    })
    .catch(function (err) {
      btn.classList.remove('rv-card__btn--loading');
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
        var n = c.item_count;
        document.querySelectorAll('cart-icon').forEach(function (icon) {
          var refs = icon.refs;
          var bc = refs ? refs.cartBubbleCount : icon.querySelector('[ref="cartBubbleCount"]');
          var bb = refs ? refs.cartBubble : icon.querySelector('[ref="cartBubble"]');
          if (!bc || !bb) return;
          bc.textContent = (n > 0 && n < 100) ? String(n) : '';
          bc.classList.toggle('hidden', n === 0);
          bb.classList.toggle('visually-hidden', n === 0);
          bb.setAttribute('data-count', String(n));
          icon.classList.toggle('header-actions__cart-icon--has-cart', n > 0);
        });
        document.querySelectorAll('[data-cart-count-badge]').forEach(function (el) {
          if (n > 0) { el.textContent = String(n); el.hidden = false; }
          else { el.hidden = true; }
        });
      }).catch(function () {});
      console.warn('[rv-card] add failed:', err);
    });
  }, true);
})();

/* ═══════════════════════════════════════════════════════════════
   Cart-drawer eyebrow count synchroniser
   ───────────────────────────────────────────────────────────────
   The "N Artikel" eyebrow at the top of the cart drawer lives in
   sections/header.liquid, OUTSIDE the cart-items section that
   Shopify re-fetches on cart:update. Without this sync, adding an
   item from "Wird oft zusammen gekauft" / "Zuletzt angesehen"
   leaves the count stale until the next full page reload.
   ═══════════════════════════════════════════════════════════════ */
(function () {
  function syncEyebrow(count) {
    var els = document.querySelectorAll('[data-cart-count-badge]');
    if (!els.length) return;
    els.forEach(function (el) {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  var pending = false;
  function refreshFromServer() {
    if (pending) return;
    pending = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { syncEyebrow(c.item_count); })
      .catch(function () {})
      .then(function () { pending = false; });
  }

  function onCartEvent(e) {
    var d = e && e.detail;
    var count = null;
    if (d) {
      if (typeof d.itemCount === 'number') count = d.itemCount;
      else if (d.data && typeof d.data.itemCount === 'number') count = d.data.itemCount;
      else if (d.cart && typeof d.cart.item_count === 'number') count = d.cart.item_count;
    }
    if (count != null) syncEyebrow(count);
    else refreshFromServer();
  }

  document.addEventListener('cart:update', onCartEvent);
  document.addEventListener('cart:refresh', onCartEvent);
  document.addEventListener('cart:add', onCartEvent);
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ── Block 2 (vormals cart-products.liquid, Zeile 1885) ── */
/*
   ═══════════════════════════════════════════════════════
   DRAWER CLOSE GUARD v3 — bulletproof inline protection
   Patches closeDialog() on the custom element instance,
   monitors dialog open state via MutationObserver,
   and blocks premature events at capture phase.
   ═══════════════════════════════════════════════════════
*/
try {
(function() {
  /* ── Track user-initiated close gestures ── */
  var userClose = false;
  function markUserClose() {
    userClose = true;
    setTimeout(function() { userClose = false; }, 1500);
  }
  document.addEventListener('pointerdown', function(e) {
    if (e.target.closest('.cart-drawer__close-button, [on\\:click*="close"]')) markUserClose();
    if (e.target.tagName === 'DIALOG' && e.target.closest('cart-drawer-component')) markUserClose();
  }, true);
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') markUserClose();
  }, true);

  /* ── Helpers ── */
  function cartHasItems() {
    return document.querySelectorAll(
      '.cart-drawer .cart-items__table-row:not(.removing):not(.swipe-removing)'
    ).length > 0;
  }

  /* ═══ LAYER 1: Capture-phase event blockers ═══ */
  document.addEventListener('cart:empty', function(e) {
    if (cartHasItems()) { e.stopImmediatePropagation(); e.stopPropagation(); }
  }, true);

  document.addEventListener('cart:update', function(e) {
    var d = e.detail;
    var cnt = (d && d.itemCount != null) ? d.itemCount : (d && d.data && d.data.itemCount);
    if (cnt === 0 && cartHasItems()) { e.stopImmediatePropagation(); e.stopPropagation(); }
  }, true);

  /* ═══ LAYER 2: Patch closeDialog() on <cart-drawer-component> instance ═══
     closeDialog is an arrow-function class field on each instance.
     When theme code calls this.closeDialog(), it resolves via the
     instance property — so overriding it here is picked up immediately. */
  function patchDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer || drawer.__closeGuard) return !!drawer;

    var origClose = drawer.closeDialog;
    if (typeof origClose !== 'function') return false;

    drawer.closeDialog = async function() {
      if (userClose || !cartHasItems()) {
        return origClose();
      }
      /* Cart still has items → block auto-close */
    };
    drawer.__closeGuard = true;

    /* Also patch dialog.close() as a safety net */
    var dialog = drawer.querySelector('dialog');
    if (dialog && !dialog.__closeGuard) {
      var origDialogClose = HTMLDialogElement.prototype.close;
      dialog.close = function(rv) {
        if (userClose || !cartHasItems()) return origDialogClose.call(this, rv);
      };
      dialog.__closeGuard = true;
    }
    return true;
  }

  /* ═══ LAYER 3: MutationObserver — re-open dialog if it loses open attribute
     while cart has items (catches morph replacements, edge cases) ═══ */
  function watchDialog() {
    var dialog = document.querySelector('cart-drawer-component dialog');
    if (!dialog) return false;

    new MutationObserver(function(muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].attributeName === 'open' && !dialog.open && cartHasItems() && !userClose) {
          queueMicrotask(function() {
            if (!dialog.open && cartHasItems() && !userClose) {
              var comp = dialog.closest('cart-drawer-component');
              if (comp && typeof comp.showDialog === 'function') {
                comp.showDialog();
              } else {
                try { dialog.showModal(); } catch(e) {}
              }
            }
          });
          break;
        }
      }
    }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    return true;
  }

  /* ── Initialize with retries (elements may not exist yet) ── */
  function init() {
    var patched = patchDrawer();
    var watched = watchDialog();
    return patched && watched;
  }

  if (!init()) {
    var t = 0;
    var iv = setInterval(function() {
      if (init() || ++t > 40) clearInterval(iv);
    }, 200);
  }
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ── Block 3 (vormals cart-products.liquid, Zeile 1998) ── */
try {
(function () {
  /* Page scrim behind the drawer, as a REAL element managed by JS.
     ::backdrop and body:has(...)::after both mis-composited on the
     merchant's Safari (the Sofort-startklar banner kept full brightness,
     a rectangular hole in the dim). A plain <div> appended to <body>
     cannot be skipped by any engine's compositor. Styled via
     #kx-cart-scrim in the stylesheet block (solid rgba, no blur). */
  function syncScrim(dialog) {
    var scrim = document.getElementById('kx-cart-scrim');
    if (dialog.open) {
      if (!scrim) {
        scrim = document.createElement('div');
        scrim.id = 'kx-cart-scrim';
        scrim.setAttribute('aria-hidden', 'true');
        document.body.appendChild(scrim);
      }
    } else if (scrim) {
      scrim.remove();
    }
  }

  function init() {
    var dialog = document.querySelector('.cart-drawer__dialog');
    if (!dialog) return false;
    new MutationObserver(function () { syncScrim(dialog); })
      .observe(dialog, { attributes: true, attributeFilter: ['open'] });
    syncScrim(dialog);
    return true;
  }

  if (!init()) {
    var t = 0;
    var iv = setInterval(function () {
      if (init() || ++t > 40) clearInterval(iv);
    }, 200);
  }
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ── Block 4 (vormals cart-products.liquid, Zeile 2038) ── */
/*
   ═══════════════════════════════════════════════════════
   MASTER CART REMOVE — unified removal with full re-render
   Handles: X-button, swipe-delete, swipe-wishlist, wishlist-btn
   Fetches with sections param → updates summary, totals,
   checkout, payment, badge. Closes drawer when empty.
   ═══════════════════════════════════════════════════════
*/
try {
(function() {
  /* ── Helpers ── */
  function getSectionId() {
    var c = document.querySelector('.cart-drawer cart-items-component');
    return c && c.dataset ? c.dataset.sectionId : null;
  }

  function updateBadge(count) {
    /* (Social proof badge should not be updated with item count) */
    /* Mobile menu badge */
    var mmBadge = document.querySelector('.cmm-cart-count');
    if (mmBadge) {
      mmBadge.textContent = count > 0 ? String(count) : '0';
      mmBadge.style.display = count > 0 ? 'flex' : 'none';
    }
    /* Cart drawer count badge next to "Warenkorb". */
    var badges = document.querySelectorAll('[data-cart-count-badge]');
    badges.forEach(function (el) {
      if (count > 0) {
        el.textContent = String(count);
        el.hidden = false;
      } else {
        el.hidden = true;
      }
    });
  }

  /**
   * Directly update the <cart-icon> badge without dispatching cart:update.
   * This avoids triggering component-cart-items.js re-morph which would
   * undo our visual row removal animation.
   */
  function updateCartIconBadge(count) {
    var icons = document.querySelectorAll('cart-icon');
    icons.forEach(function(icon) {
      /* Try refs first (set by Component.connectedCallback) */
      var refs = icon.refs;
      var bubbleCount = refs ? refs.cartBubbleCount : icon.querySelector('[ref="cartBubbleCount"]');
      var bubble      = refs ? refs.cartBubble      : icon.querySelector('[ref="cartBubble"]');
      if (!bubbleCount || !bubble) return;

      /* Update text */
      bubbleCount.textContent = (count > 0 && count < 100) ? String(count) : '';
      /* Update visibility */
      bubbleCount.classList.toggle('hidden', count === 0);
      bubble.classList.toggle('visually-hidden', count === 0);
      bubble.setAttribute('data-count', String(count));
      /* Update parent class */
      icon.classList.toggle('header-actions__cart-icon--has-cart', count > 0);
    });
    /* Persist for back-button restoration */
    try {
      sessionStorage.setItem('cart-count', JSON.stringify({
        value: String(count),
        timestamp: Date.now()
      }));
    } catch(e) {}
  }

  function updateDrawerHeadingCount(count) {
    var el = document.querySelector('.cart-drawer__count');
    if (el) el.textContent = count > 0 ? String(count) : '';
  }

  function closeDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    if (!drawer) return;
    if (typeof drawer.closeDialog === 'function') {
      drawer.closeDialog();
    } else {
      var dlg = drawer.querySelector('dialog');
      if (dlg && dlg.open) try { dlg.close(); } catch(e) {}
    }
  }

  /**
   * Render the full empty-cart state (replaces entire cart-items-component body).
   */
  function renderEmptyState(sectionId, sectionHTML) {
    var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var newSection = doc.getElementById('shopify-section-' + sectionId);
    if (!newSection) return;
    var existingComp = document.querySelector('#shopify-section-' + sectionId + ' cart-items-component');
    var newComp = newSection.querySelector('cart-items-component');
    if (existingComp && newComp) {
      existingComp.innerHTML = newComp.innerHTML;
    }
    /* Also update the dialog class for empty styling */
    var dlg = document.querySelector('.cart-drawer__dialog');
    if (dlg) dlg.classList.add('cart-drawer--empty');
  }

  /* ═══════════════════════════════════════════════════════
     __cartMasterRemove(key, row, opts)
     Single entry point for ALL cart item removals.
     - key: the cart line-item key
     - row: the DOM <tr> element
     - opts.animDelay: ms to wait for row animation (default 450)
     - opts.skipAnim: if row is already animated
     Returns a Promise.
     ═══════════════════════════════════════════════════════ */
  /* All cart mutations from this pipeline run through ONE promise chain.
     Two quick swipe-removals used to race: /cart/change.js responses can
     arrive out of order, and the older response's item_count would then
     overwrite the newer badge/summary. The queue serialises the requests
     so the last update always reflects the true final cart. */
  var opQueue = Promise.resolve();
  function enqueue(fn) {
    /* An op that never settles (hung fetch) must not wedge the queue
       forever — race every op against a hard timeout. */
    var wrapped = function() {
      return Promise.race([
        fn(),
        new Promise(function(_, reject) {
          setTimeout(function() { reject(new Error('cart op timeout')); }, 8000);
        })
      ]);
    };
    var run = opQueue.then(wrapped, wrapped);
    /* keep the chain alive after a failure */
    opQueue = run.catch(function() {});
    return run;
  }

  /* Variant ids of rows whose removal is queued but not yet confirmed —
     used to keep them visually collapsed across tbody re-renders. */
  var pendingRemovals = new Set();

  /* Re-render rows + summary from fresh section HTML. This is THE fix for
     the "second removal never happens" bug: Shopify RE-GENERATES the line
     keys of the REMAINING items after a cart mutation whenever an automatic
     discount is re-allocated (measured live: the key hash of an untouched
     line changed after another line was removed). Rows keyed at page-render
     time therefore go stale after the first removal, and the next
     /cart/change.js with such a key answers 400 "keine gültigen ID- oder
     Zeilenparameter" while our old code showed the row as removed anyway.
     Re-rendering the tbody from every response keeps the DOM keys fresh. */
  function renderCartFromSectionHTML(sectionId, sectionHTML) {
    var doc = new DOMParser().parseFromString(sectionHTML, 'text/html');
    var newTbody = doc.querySelector('tbody[role="rowgroup"]');
    var oldTbody = document.querySelector('.cart-drawer tbody[role="rowgroup"]');
    if (newTbody && oldTbody) {
      oldTbody.replaceWith(newTbody);
    } else if (newTbody && !oldTbody) {
      /* drawer was in its empty state — rebuild the whole component body */
      var oldComp = document.querySelector('.cart-drawer cart-items-component');
      var newComp = doc.querySelector('cart-items-component');
      if (oldComp && newComp) oldComp.innerHTML = newComp.innerHTML;
    }
    var newSummary = doc.querySelector('.cart-drawer__summary');
    var oldSummary = document.querySelector('.cart-drawer__summary');
    if (newSummary && oldSummary) oldSummary.innerHTML = newSummary.innerHTML;
    /* rows queued for removal stay collapsed across the re-render */
    pendingRemovals.forEach(function(vid) {
      var r = document.querySelector('.cart-drawer tr.cart-items__table-row[data-variant-id="' + vid + '"]');
      if (r) r.classList.add('removing');
    });
  }

  /* Pull server truth into the drawer (rows + summary + all badges).
     Called whenever a removal fails, so a "visually removed but still in
     the cart" ghost can never survive: the row comes back, the badges
     match the server, and the next tap works with a fresh key. */
  function resyncFromServer(sectionId) {
    fetch('/?sections=' + encodeURIComponent(sectionId))
      .then(function(r) { return r.json(); })
      .then(function(s) {
        var html = s && s[sectionId];
        if (html) renderCartFromSectionHTML(sectionId, html);
      })
      .catch(function() {});
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(c) {
        updateBadge(c.item_count);
        updateCartIconBadge(c.item_count);
        updateDrawerHeadingCount(c.item_count);
      })
      .catch(function() {});
  }

  window.__cartMasterRemove = function(key, row, opts) {
    opts = opts || {};
    var sectionId = getSectionId();
    if (!key || !sectionId) return Promise.reject('Missing key or sectionId');
    var animDelay = opts.animDelay || 450;
    var vid = row && row.dataset ? row.dataset.variantId : null;
    if (vid) pendingRemovals.add(vid);
    function settle() { if (vid) pendingRemovals.delete(vid); }

    var run = enqueue(function() {
      /* The key captured at click time can be stale by the time this queued
         op runs (see renderCartFromSectionHTML). Re-resolve it from the
         live DOM — the variant id is stable across key re-generations. */
      var liveKey = key;
      if (vid) {
        var liveRow = document.querySelector('.cart-drawer tr.cart-items__table-row[data-variant-id="' + vid + '"]');
        if (liveRow && liveRow.dataset.key) liveKey = liveRow.dataset.key;
      }
      return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: liveKey,
        quantity: 0,
        sections: sectionId,
        sections_url: window.location.pathname
      })
    })
    .then(function(r) {
      return r.json().catch(function() { return {}; }).then(function(data) {
        /* Shopify answers 400 {"status":"bad_request", …} on a stale key.
           The old code ignored this and removed the row anyway — the exact
           ghost the merchant reported. Treat anything without a numeric
           item_count as a hard failure. */
        if (!r.ok || data.status || typeof data.item_count !== 'number') {
          throw new Error('cart change rejected: ' + (data.message || data.status || r.status));
        }
        return data;
      });
    })
    .then(function(data) {
      var sectionHTML = data.sections ? data.sections[sectionId] : null;

      updateBadge(data.item_count);
      updateCartIconBadge(data.item_count);
      updateDrawerHeadingCount(data.item_count);

      if (data.item_count === 0) {
        /* ── Cart is now empty ── */
        setTimeout(function() {
          if (sectionHTML) renderEmptyState(sectionId, sectionHTML);
          document.dispatchEvent(new CustomEvent('cart:empty', { bubbles: true, composed: true }));
          setTimeout(closeDrawer, 80);
        }, animDelay);
      } else {
        /* ── Cart still has items — re-render rows + summary NOW, inside
           the queued op, so the next queued removal already sees the
           fresh keys in the DOM. ── */
        if (sectionHTML) {
          renderCartFromSectionHTML(sectionId, sectionHTML);
        } else if (row) {
          setTimeout(function() { row.remove(); }, animDelay);
        }
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: data } }));
      }

      return data;
    })
    .catch(function(err) {
      resyncFromServer(sectionId);
      throw err;
    });
    });
    run.then(settle, settle);
    return run;
  };

  /* ═══════════════════════════════════════════════════════
     __cartMasterAddBack(variantId, qty)
     Undo for an immediate swipe-removal: re-adds the line via
     /cart/add.js and re-renders rows + summary + badges from the
     bundled section HTML. Runs through the same op queue as
     removals, so undo can never race a removal response.
     ═══════════════════════════════════════════════════════ */
  window.__cartMasterAddBack = function(variantId, qty) {
    var sectionId = getSectionId();
    if (!variantId || !sectionId) return Promise.reject('Missing variantId or sectionId');

    return enqueue(function() {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(variantId, 10), quantity: parseInt(qty, 10) || 1 }],
          sections: sectionId,
          sections_url: window.location.pathname
        })
      })
      .then(function(r) { return r.json(); })
      .then(function(data) {
        var sectionHTML = data.sections ? data.sections[sectionId] : null;
        if (sectionHTML) {
          /* Rows + summary from fresh HTML (handles the empty-state case
             — last item removed, then undo — via the component rebuild
             inside the shared helper). */
          renderCartFromSectionHTML(sectionId, sectionHTML);
          /* If the drawer had flipped to empty styling, undo it */
          var dlg = document.querySelector('.cart-drawer__dialog');
          if (dlg) dlg.classList.remove('cart-drawer--empty');
        }
        /* /cart/add.js has no item_count → read it from the fresh badge */
        return fetch('/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
          updateBadge(cart.item_count);
          updateCartIconBadge(cart.item_count);
          updateDrawerHeadingCount(cart.item_count);
          document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart } }));
          return cart;
        });
      });
    });
  };

  /* ═══ INTERCEPT X-BUTTON CLICKS ═══
     Capture phase — runs BEFORE the theme component's on:click routing.
     We handle the removal ourselves with sections re-rendering. */
  document.addEventListener('click', function(e) {
    var btn = e.target.closest('.cart-drawer .cart-items__remove');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    var row = btn.closest('tr.cart-items__table-row');
    if (!row || !row.dataset.key) return;

    /* Animate collapse (matches theme's native .removing animation) */
    row.style.setProperty('--row-height', row.clientHeight + 'px');
    row.classList.add('removing');

    window.__cartMasterRemove(row.dataset.key, row, { animDelay: 500 })
      .catch(function() {
        row.classList.remove('removing');
        row.style.removeProperty('--row-height');
      });
  }, true); /* capture phase */
})();
} catch (e) { setTimeout(function () { throw e; }); }

/* ── Block 5 (vormals cart-products.liquid, Zeile 2375) ── */
try {
  document.addEventListener('DOMContentLoaded', () => {

    // 1. Initial Check: Updates UI based on localStorage
    const updateWishlistUI = () => {
      try {
        let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        wishlist = wishlist.map(i => typeof i === 'string' ? i.trim() : i).filter(Boolean);

        const containers = document.querySelectorAll('.cart-wishlist-container');
        containers.forEach(container => {
          const handle = container.dataset.handle;
          if (!handle) return;

          if (wishlist.includes(handle)) {
             container.classList.add('in-wishlist');
          } else {
             container.classList.remove('in-wishlist');
          }
        });
      } catch (e) {
        console.error('DEBUG: Error in updateWishlistUI:', e);
      }
    };

    updateWishlistUI();
    // Re-check if wishlist updates elsewhere (e.g. storage event maybe?)
    window.addEventListener('wishlist-updated', updateWishlistUI);


    // Toast Logic
    const showToast = (message) => {
      const toast = document.getElementById('wishlist-toast');
      if (!toast) return;
      
      if (message) {
        const span = toast.querySelector('span');
        if (span) span.textContent = message;
      }
      
      toast.classList.add('show');
      toast.setAttribute('aria-hidden', 'false');
      
      setTimeout(() => {
        toast.classList.remove('show');
        toast.setAttribute('aria-hidden', 'true');
      }, 4000);
    };

    // Use delegation for dynamic cart updates
    document.body.addEventListener('click', (e) => {
      const btn = e.target.closest('.cart-wishlist-btn');
      if (!btn) return;
      e.preventDefault();
      const handle = btn.dataset.handle;
      if (!handle) return;

      // Toggle active state visually
      const container = btn.closest('.cart-wishlist-container');
      if (container) {
        container.classList.add('in-wishlist');
        btn.style.display = 'none';
        const activeDiv = container.querySelector('.cart-wishlist-active');
        if (activeDiv) activeDiv.style.display = 'flex';
      }

        // 1. Add to Wishlist
        let wishlist = JSON.parse(localStorage.getItem('wishlist') || '[]');
        wishlist = wishlist.map(i => typeof i === 'string' ? i.trim() : i).filter(Boolean);
        
        if (!wishlist.includes(handle)) {
          wishlist.push(handle);
          localStorage.setItem('wishlist', JSON.stringify(wishlist));
          window.dispatchEvent(new Event('wishlist-updated')); 
          showToast(((window.KX_CART_I18N || {}).wlAdded || ''));
        } else {
          showToast(((window.KX_CART_I18N || {}).wlExists || ''));
        }

        // 2. Remove from Cart via masterRemove
        const row = btn.closest('tr');
        if (row && row.dataset.key) {
           btn.style.opacity = '0.5';
           btn.style.pointerEvents = 'none';
           row.style.transition = 'opacity 0.5s, transform 0.5s';
           row.style.opacity = '0';
           row.style.transform = 'translateX(20px)';
           row.classList.add('removing');

           window.__cartMasterRemove(row.dataset.key, row, { animDelay: 500 })
             .catch(function(err) {
               console.error('Error removing item:', err);
               row.style.opacity = '';
               row.style.transform = '';
             });
        }
    });

    // FAILSAFE: Find and hide phantom duplicate buttons
    const hidePhantomButtons = () => {
       const allButtons = document.querySelectorAll('button, a, div[role="button"]');
       allButtons.forEach(el => {
         if (el.textContent.trim() === 'Auf den Wunschzettel' && !el.classList.contains('cart-wishlist-btn')) {
           el.style.display = 'none';
           el.style.visibility = 'hidden';
         }
       });
    };
    // Run repeatedly in case of dynamic rendering
    setTimeout(hidePhantomButtons, 500);
    setTimeout(hidePhantomButtons, 1500);
    setTimeout(hidePhantomButtons, 3000);

    /* X-button removal is now handled by the capture-phase interceptor
       in the MASTER CART REMOVE script above. */
  });
} catch (e) { setTimeout(function () { throw e; }); }

/* ── Block 6 (vormals cart-products.liquid, Zeile 2493) ── */
/*
   Swipe JS — left to reveal Entfernen — 60fps GPU
*/
try {
(function() {
  // This used to open with `return;`, disabled because the gesture panned the
  // cart sideways. That cause is gone: every scrollable ancestor now clips
  // horizontally — .cart-drawer__content has `overflow-x: clip` plus
  // `contain: layout style paint` (assets/header-actions.css), and the cart
  // page locks html, body, .cart-page and .cart-items-component. The action
  // layer parks 120px beyond the row, so those clips are what hold it in.
  if (window.matchMedia('(min-width: 750px)').matches) return;

  const THRESHOLD = 60;
  const MAX = 120;
  const FULL_VEL = 1.6;
  const RUBBER = 0.28;

  let row = null;
  let sx = 0, sy = 0, cx = 0;
  let lastX = 0, lastT = 0, vel = 0;
  let swiping = false, scrolling = false, decided = false;
  let dir = 0; // -1 = left (delete), +1 = right (wish), 0 = undecided
  let raf = null;
  let undoTimer = null, undoStack = [];
  let wishSnackTimer = null;

  const haptic = () => { if (navigator.vibrate) navigator.vibrate(8); };

  const targets = r => r.querySelectorAll(':scope > td:not(.swipe-delete-layer), :scope > button.cart-items__remove');

  function paint(r, x) {
    const t3d = 'translate3d(' + x + 'px,0,0)';
    targets(r).forEach(el => { el.style.transform = t3d; });

    const delLayer = r.querySelector('.swipe-delete-layer');
    const wishLayer = r.querySelector('.swipe-wish-layer');

    if (x < 0 && delLayer) {
      const reveal = Math.min(Math.abs(x), MAX);
      delLayer.style.transform = 'translate3d(' + (MAX - reveal) + 'px,0,0)';
      delLayer.classList.toggle('revealed', Math.abs(x) > 28);
      // Hide the other
      if (wishLayer) wishLayer.style.transform = 'translate3d(-100%,0,0)';
    } else if (x > 0 && wishLayer) {
      const reveal = Math.min(x, MAX);
      wishLayer.style.transform = 'translate3d(' + (reveal - MAX) + 'px,0,0)';
      wishLayer.classList.toggle('revealed', x > 28);
      if (delLayer) delLayer.style.transform = 'translate3d(100%,0,0)';
    } else {
      if (delLayer) { delLayer.style.transform = 'translate3d(100%,0,0)'; delLayer.classList.remove('revealed'); }
      if (wishLayer) { wishLayer.style.transform = 'translate3d(-100%,0,0)'; wishLayer.classList.remove('revealed'); }
    }
  }

  function frame(r, x) {
    if (raf) cancelAnimationFrame(raf);
    raf = requestAnimationFrame(() => { paint(r, x); raf = null; });
  }

  function closeRow(r) {
    if (!r) return;
    r.classList.remove('swiping', 'swiped-left', 'swiped-right');
    r.classList.add('snapping');
    paint(r, 0);
    setTimeout(() => r.classList.remove('snapping'), 480);
  }

  function openLeft(r) {
    r.classList.remove('swiping');
    r.classList.add('snapping', 'swiped-left');
    paint(r, -MAX);
    haptic();
    setTimeout(() => r.classList.remove('snapping'), 480);
  }

  function openRight(r) {
    r.classList.remove('swiping');
    r.classList.add('snapping', 'swiped-right');
    paint(r, MAX);
    haptic();
    setTimeout(() => r.classList.remove('snapping'), 480);
  }

  // ── DELETE ──
  function fullDelete(r) {
    haptic();
    r.classList.remove('swiping', 'swiped-left');
    r.classList.add('swipe-full-remove');
    r.querySelector('.swipe-delete-layer')?.classList.add('revealed');
    setTimeout(() => removeItem(r), 280);
  }

  /* Removal is IMMEDIATE. It used to be deferred 4.5s behind the undo
     snackbar with a single pendingDelete slot — a second swipe inside the
     window overwrote the first, whose delete then never reached the server:
     the row was gone visually but badge + summary still counted it (ghost
     item), and closing the drawer lost the delete entirely. Now every swipe
     fires /cart/change.js at once (badge/summary update per response, in
     order via the master op queue) and "undo" re-ADDS the line instead. */
  function removeItem(r) {
    const key = r.dataset.key;
    if (!key) return;
    const h = r.offsetHeight + parseInt(getComputedStyle(r).marginBottom || 0);
    r.style.maxHeight = h + 'px';
    r.offsetHeight;
    r.classList.add('swipe-removing');
    haptic();

    const sb = document.getElementById('swipe-undo-snackbar');
    if (sb && r.dataset.variantId) {
      undoStack.push({ variantId: r.dataset.variantId, qty: r.dataset.qty || '1' });
      sb.classList.add('show');
      clearTimeout(undoTimer);
      undoTimer = setTimeout(function() {
        sb.classList.remove('show');
        undoStack = [];
      }, 4500);
    }
    doRemove(key, r);
  }

  function doRemove(key, r) {
    window.__cartMasterRemove(key, r, { animDelay: 450 })
      .catch(function() {
        r.classList.remove('swipe-removing', 'swipe-full-remove');
        r.style.maxHeight = '';
        closeRow(r);
      });
  }

  // ── WISHLIST ──
  function fullWish(r) {
    haptic();
    r.classList.remove('swiping', 'swiped-right');
    r.classList.add('swipe-full-wish');
    const wl = r.querySelector('.swipe-wish-layer');
    if (wl) { wl.classList.add('revealed', 'wish-triggered'); }
    setTimeout(() => doWishlist(r), 350);
  }

  function doWishlist(r) {
    const handle = r.querySelector('[data-handle]')?.dataset.handle;
    if (!handle) return;

    // Add to localStorage wishlist
    let wl = [];
    try { wl = JSON.parse(localStorage.getItem('wishlist') || '[]'); } catch(e) {}
    wl = wl.map(i => typeof i === 'string' ? i.trim() : i).filter(Boolean);
    if (!wl.includes(handle)) {
      wl.push(handle);
      localStorage.setItem('wishlist', JSON.stringify(wl));
      window.dispatchEvent(new Event('wishlist-updated'));
    }

    // Heart pop animation
    const wishLayer = r.querySelector('.swipe-wish-layer');
    if (wishLayer) wishLayer.classList.add('wish-triggered');

    // Show wishlist feedback snackbar
    const wsb = document.getElementById('swipe-wish-snackbar');
    if (wsb) {
      wsb.classList.add('show');
      clearTimeout(wishSnackTimer);
      wishSnackTimer = setTimeout(() => wsb.classList.remove('show'), 3000);
    }

    // Remove from cart via masterRemove
    const key = r.dataset.key;
    if (key) {
      const h = r.offsetHeight + parseInt(getComputedStyle(r).marginBottom || 0);
      r.style.maxHeight = h + 'px';
      r.offsetHeight;
      r.classList.add('swipe-removing');

      window.__cartMasterRemove(key, r, { animDelay: 450 })
        .catch(function() {
          r.classList.remove('swipe-removing', 'swipe-full-wish');
          r.style.maxHeight = '';
          closeRow(r);
        });
    }
  }

  // ── Undo button ──
  const undoBtn = document.getElementById('swipe-undo-btn');
  if (undoBtn) {
    undoBtn.addEventListener('click', () => {
      const entry = undoStack.pop();
      const sb = document.getElementById('swipe-undo-snackbar');
      if (undoStack.length === 0) {
        clearTimeout(undoTimer);
        if (sb) sb.classList.remove('show');
      } else {
        /* more removals to undo — keep the snackbar up a little longer */
        clearTimeout(undoTimer);
        undoTimer = setTimeout(function() {
          if (sb) sb.classList.remove('show');
          undoStack = [];
        }, 4500);
      }
      if (entry && window.__cartMasterAddBack) {
        window.__cartMasterAddBack(entry.variantId, entry.qty).catch(function() {});
      }
    });
  }

  // ── TOUCH START ──
  document.addEventListener('touchstart', function(e) {
    const r = e.target.closest('.swipe-row');
    if (!r || e.target.closest('.quantity-selector, input, select, .swipe-delete-layer, .swipe-wish-layer')) return;

    // Close other open rows
    document.querySelectorAll('.swipe-row.swiped-left, .swipe-row.swiped-right').forEach(o => {
      if (o !== r) closeRow(o);
    });

    const t = e.touches[0];
    sx = t.clientX; sy = t.clientY;
    cx = 0; vel = 0; dir = 0;
    lastX = t.clientX; lastT = Date.now();
    swiping = false; scrolling = false; decided = false;
    row = r;
  }, { passive: true });

  // ── TOUCH MOVE (60fps) ──
  document.addEventListener('touchmove', function(e) {
    if (!row) return;
    const t = e.touches[0];
    const dx = t.clientX - sx;
    const dy = t.clientY - sy;

    if (!decided) {
      // Ambiguous diagonals go to the browser, not to us: scrolling past a row
      // must never be mistaken for a swipe. (This was `* 1.2`, which tipped
      // near-diagonal drags into the swipe.)
      if (Math.abs(dy) > 6 && Math.abs(dy) >= Math.abs(dx)) {
        scrolling = true; decided = true; row = null; return;
      }
      // Left only. The wishlist layer that right-swipe used to reveal is no
      // longer rendered, so a rightward drag must stay the browser's — not
      // slide the row open onto empty space.
      if (dx < -6) {
        swiping = true; decided = true;
        dir = -1;
        row.classList.add('swiping');
        row.classList.remove('snapping', 'swiped-left', 'swiped-right');
        sx = t.clientX; // zero-jump reset
      } else { return; }
    }

    if (scrolling) return;
    e.preventDefault();

    // Velocity
    const now = Date.now();
    const dt = now - lastT;
    if (dt > 0) vel = (lastX - t.clientX) / dt; // positive = left
    lastX = t.clientX; lastT = now;

    let raw = t.clientX - sx;

    // Lock direction after first decision
    if (dir === -1 && raw > 0) raw = 0;
    if (dir === 1 && raw < 0) raw = 0;

    // Rubber-band past max
    const abs = Math.abs(raw);
    let offset;
    if (abs > MAX) {
      offset = (raw > 0 ? 1 : -1) * (MAX + (abs - MAX) * RUBBER);
    } else {
      offset = raw;
    }

    cx = offset;
    frame(row, offset);
  }, { passive: false });

  // ── TOUCH END ──
  document.addEventListener('touchend', function() {
    if (raf) { cancelAnimationFrame(raf); raf = null; }
    if (!row || !swiping) { row = null; return; }

    const r = row;
    row = null;
    r.classList.remove('swiping');

    const abs = Math.abs(cx);
    const absVel = Math.abs(vel);

    if (dir === -1) {
      // LEFT swipe → delete
      if (vel > FULL_VEL || abs > MAX * 1.15) { fullDelete(r); return; }
      if (abs >= THRESHOLD || vel > 0.5) { openLeft(r); }
      else { closeRow(r); }
    } else if (dir === 1) {
      // RIGHT swipe → wishlist
      if (-vel > FULL_VEL || abs > MAX * 1.15) { fullWish(r); return; }
      if (abs >= THRESHOLD || absVel > 0.5) { openRight(r); }
      else { closeRow(r); }
    } else {
      closeRow(r);
    }
  }, { passive: true });

  // ── Tap action layers ──
  document.addEventListener('click', function(e) {
    const del = e.target.closest('.swipe-delete-layer');
    if (del) { const r = del.closest('.swipe-row'); if (r) removeItem(r); return; }

    const wish = e.target.closest('.swipe-wish-layer');
    if (wish) { const r = wish.closest('.swipe-row'); if (r) doWishlist(r); return; }
  });

  // Close on scroll
  let st;
  document.addEventListener('scroll', function() {
    clearTimeout(st);
    st = setTimeout(() => {
      document.querySelectorAll('.swipe-row.swiped-left, .swipe-row.swiped-right').forEach(closeRow);
    }, 150);
  }, { passive: true });

  // Close on outside tap
  document.addEventListener('touchstart', function(e) {
    if (!e.target.closest('.swipe-row.swiped-left, .swipe-row.swiped-right, .swipe-snackbar')) {
      document.querySelectorAll('.swipe-row.swiped-left, .swipe-row.swiped-right').forEach(closeRow);
    }
  }, { passive: true });

})();
} catch (e) { setTimeout(function () { throw e; }); }
